import { createFileRoute } from "@tanstack/react-router";
import { BillingPage } from "@/features/settings/billing-page";

export const Route = createFileRoute("/_app/settings/billing")({ component: BillingPage });
